import { get, put } from "./db.js";
import { DEFAULT_DSP_CONFIG, setDspConfig, } from "../engine/dsp.js";
const KEY = "dsp";
export async function loadDspConfig() {
    const saved = await get("prefs", KEY);
    const merged = { ...DEFAULT_DSP_CONFIG, ...(saved ?? {}) };
    setDspConfig(merged);
    if (saved) {
        console.info("[dsp-config] loaded persisted DSP config", merged);
    }
    else {
        console.info("[dsp-config] no saved DSP config; using defaults");
    }
    return merged;
}
export async function saveDspConfig(patch) {
    setDspConfig(patch);
    const current = await get("prefs", KEY);
    const next = {
        ...DEFAULT_DSP_CONFIG,
        ...(current ?? {}),
        ...patch,
    };
    await put("prefs", KEY, next);
    console.debug("[dsp-config] persisted DSP config", next);
}
